import React from 'react'
import moment from 'moment'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../../Camiones/containers/busquedaCpa/InfoCpa'

export const COLUMNS_CAMIONES_VOLCADOS = [
  {
    name: 'fechaDeVolcado',
    label: 'Fecha de volcado',
    options: {
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cartaDePorteAutomotor',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'corredorComprador',
    label: 'Corredor',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'chofer',
    label: 'Chofer',
    options: {
      filter: false,
      sort: true,
      display: false
    }
  },
  {
    name: 'volcador',
    label: 'Volcador',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'volcadoraCamiones',
    label: 'Volcadora',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'fechaDeBruto',
    label: 'Fecha de bruto',
    options: {
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (f) => {
        return moment(f).format('DD-MM-YYYY HH:mm')
      }
    }
  },
  {
    name: 'pesoBruto',
    label: 'Peso bruto',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  },
  {
    name: 'calificacionCereal',
    label: 'Calificacion cereal',
    options: {
      filter: true,
      sort: true
    }
  }

]
export const COLUMNS_CAMIONES_VOLCADOS_TO_PRINT = [
  {
    name: 'fechaDeVolcado',
    label: 'Fecha Volcado',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 50,
    mantenerCase: true
  },

  {
    name: 'fechaDeBruto',
    label: 'Fecha de bruto',
    width: 70,
    mantenerCase: true
  },

  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'corredorComprador',
    label: 'Corredor',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'volcador',
    label: 'Volcador',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'volcadoraCamiones',
    label: 'Volcadora camiones',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camión',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoBruto',
    label: 'Peso bruto',
    width: 60,
    mantenerCase: true
  }
]
